import EmberRouter from "@ember/routing/router";

import EmberApp from "ember-strict-application-resolver";

import ApplicationTemplate from "./templates/application.gts";

class Router extends EmberRouter {
  // The demo has no routes and is served from a project path on GitHub Pages,
  // so "none" avoids any base-URL handling. It just renders the application
  // template.
  location = "none";
  rootURL = "/";
}

Router.map(function () {});

export class App extends EmberApp {
  // The strict resolver has no auto-discovery, so every module the app needs
  // is listed here under its `./type/name` key. This demo only needs the
  // router and the application template.
  modules = {
    "./router": Router,
    "./templates/application": ApplicationTemplate,
  };
}
